/* eslint-disable no-case-declarations */
import * as Modules from 'src/modules/constants';
import { getEntityDetailsInputsMap } from 'src/modules/revyre/details/selectors';
// import { BASE_URL, getRequestHeaders } from 'src/modules/revyre/thunk';
import { store } from 'src/store';
// import axios from 'src/workspace/axios';
import { renderDialog } from '../slice';
import { getDecryptedEnvValue } from '../utils';

export const checkIfFCMKeysPresent = () =>
  !!getDecryptedEnvValue('FCM_API_KEY');

export const handleOnMessageReceived = async (data) => {
  const action = JSON.parse(data?.data?.actions)?.[0]?.code;

  switch (action) {
    case 'update-state':
    default:
      const { hash } = window.location;
      const workflowId = hash.split('/').pop();
      const state = store.getState();
      const activityType = getEntityDetailsInputsMap(
        state,
        workflowId,
      )?.activityType;
      store.dispatch(
        renderDialog({
          id: Modules.REVYRE_NOTIFICATION,
          props: {
            activityType,
          },
        }),
      );
      break;
  }
};
